import { preventLinkDefault } from "./utils";
import { Animation } from "./animations";
import { MediaBreakpoint } from "./media_breakpoint";


// *************************************************************************
// Otevírání/zavírání nabídek se slide efektem a s možností exklusivity
// (tj. vždy pouze jedna nabídka z vybrané skupiny je otevřená - akordeon)
// *************************************************************************

function isTargetExpanded(target) {
	// Zjišťování přes třídy nestačí. Aby to fungovalo, musíme přidat ještě kontrolu na breakpointy.
	return target.classList.contains("expanded") ||
		(target.classList.contains("expanded-sm") && MediaBreakpoint.up("sm")) ||
		(target.classList.contains("expanded-md") && MediaBreakpoint.up("md")) ||
		(target.classList.contains("expanded-lg") && MediaBreakpoint.up("lg")) ||
		(target.classList.contains("expanded-xl") && MediaBreakpoint.up("xl"));
}

function removeExpandedClass(target) {
	target.classList.remove("expanded", "expanded-sm", "expanded-md", "expanded-lg", "expanded-xl");
}

//
// Pomocná funkce pro nastavení třídy "spouštěčům" (toggles)
//
function toggleToggleClasses(toggle, animationKind, classNames, addOrRemove) {
	// Nastavme/odstraňme třídy přímo na toggle.
	for (let i = 0; i < classNames.length; ++i) {
		toggle.classList[addOrRemove](classNames[i]);
	}

	// Každý "toggle" může mít ještě své "feedback" prvky.
	let feedbacksSelector = toggle.getAttribute("data-" + animationKind + "-feedback");
	if (feedbacksSelector) {
		let feedbacks = document.querySelectorAll(feedbacksSelector);
		for (let j = 0; j < feedbacks.length; ++j) {
			for (let i = 0; i < classNames.length; ++i) {
				feedbacks[j].classList[addOrRemove](classNames[i]);
			}
		}
	}
}


//
// Sbalit nabídku
//
function hideElements(toggles, targets, animationOut, animationKind) {
	for (let i = 0; i < toggles.length; ++i) {
		toggleToggleClasses(toggles[i], animationKind, ["collapsing"], "add");
		toggleToggleClasses(toggles[i], animationKind, ["expanded", "expanded-sm", "expanded-md", "expanded-lg", "expanded-xl"], "remove");
		toggles[i].trigger("slidetogglecollapsing");
	}
	for (let i = 0; i < targets.length; ++i) {
		targets[i].classList.add("collapsing");
		targets[i].trigger("slidetargetcollapsing");
	}

	return animationOut(targets).then(function() {
		for (let i = 0; i < toggles.length; ++i) {
			toggleToggleClasses(toggles[i], animationKind, ["collapsing"], "remove");
			toggles[i].trigger("slidetogglecollapsed");
		}
		for (let i = 0; i < targets.length; ++i) {
			targets[i].classList.remove("collapsing");
			removeExpandedClass(targets[i]);
			targets[i].trigger("slidetargetcollapsed");
		}
	});
}


//
// Rozbalit nabídku
//
function showElements(toggles, targets, animationIn, animationKind) {
	for (let i = 0; i < toggles.length; ++i) {
		toggleToggleClasses(toggles[i], animationKind, ["expanding"], "add");
		toggles[i].trigger("slidetoggleexpanding");
	}
	for (let i = 0; i < targets.length; ++i) {
		targets[i].classList.add("expanding");
		targets[i].trigger("slidetargetexpanding");
	}

	let promises = [];

	for (let i = 0; i < targets.length; ++i) {
		// TODO display
		// let display = targets[i].getAttribute("data-" + animationKind + "-display") || Animation.default.display;

		promises.push(
			animationIn(targets[i]).then(function() {
				for (let j = 0; j < toggles.length; ++j) {
					toggleToggleClasses(toggles[j], animationKind, ["expanding"], "remove");
					toggleToggleClasses(toggles[j], animationKind, ["expanded"], "add");
					toggles[j].trigger("slidetoggleexpanded");
				}
				for (let j = 0; j < targets.length; ++j) {
					targets[j].classList.remove("expanding");
					targets[j].classList.add("expanded");
					targets[j].trigger("slidetargetexpanded");
				}
			})
		);
	}

	return Promise.all(promises);
}


//
// Pro combobox a výběr variant vznikla tato specialita, kdy je možné zobrazený obsah při kliknutí
// kamkoliv jinam do prostoru obsah zavřít (něco jako jsou bubliny s nápovědou).
//
// Přes data atribut "data-sticky='ignore'" je možné při kliknutí v daném kontejneru skrývání vypnout.
//
function hideNonStickyElements(eventTarget, omitElement) {
	if (eventTarget.closest("[data-sticky='ignore']")) {
		return;
	}

	let targets = document.querySelectorAll("[data-slide][data-sticky='false'], [data-fade][data-sticky='false']");
	if (!targets.length) {
		return;
	}

	for (let i = 0; i < targets.length; ++i) {
		let target = targets[i];

		if (target == omitElement) {
			continue;
		}

		let elementSelector = target.getAttribute("data-slide") || target.getAttribute("data-fade");
		let animationKind = target.getAttribute("data-slide") ? "slide" : "fade";
		let animationOut = animationKind == "slide" ? Animation.slideUp : Animation.fadeOut;

		let toggles = document.querySelectorAll("[data-" + animationKind + "='" + elementSelector + "']");
		let elements = document.querySelectorAll(elementSelector);

		hideElements(toggles, elements, animationOut, animationKind);
	}
}


//
// Core animation
//
function animate(target, blockAnimationIfRunning) {
	blockAnimationIfRunning = blockAnimationIfRunning || false;

	// Pokud právě probíhá nějaký druh animace, tak nic nedělejme.
	if (blockAnimationIfRunning) {
		let isAnimating = target.classList.contains("expanding") || target.classList.contains("collapsing");
		if (isAnimating) {
			return;
		}
	}

	let animationKind = target.getAttribute("data-slide") ? "slide" : "fade";
	let exclusiveGroup = target.getAttribute("data-exclusive");
	let otherGroups = exclusiveGroup ? document.querySelectorAll("[data-" + animationKind + "][data-exclusive='" + exclusiveGroup + "']") : [];

	// Pokud právě probíhá nějaký druh animace na exklusivní skupině, tak nic nedělejme.
	if (blockAnimationIfRunning) {
		for (let i = 0; i < otherGroups.length; ++i) {
			let otherGroup = otherGroups[i];
			let isAnimating = otherGroup.classList.contains("expanding") || otherGroup.classList.contains("collapsing");
			if (isAnimating) {
				return;
			}
		}
	}

	let isExpanded = isTargetExpanded(target);
	let animationIn = animationKind == "slide" ? Animation.slideDown : Animation.fadeIn;
	let animationOut = animationKind == "slide" ? Animation.slideUp : Animation.fadeOut;
	let elementSelector = target.getAttribute("data-" + animationKind);
	let direction = target.getAttribute("data-direction");
	let waitForFinish = target.getAttribute("data-wait-for-finish") == "true";

	// Některá tlačítka mohou mít pouze jednosměrnou funkci (pouze otevřít/pouze zavřít).
	// Zablokujme proto opačnou funkci.
	if ((isExpanded && (direction == "down" || direction == "in")) || (!isExpanded && (direction == "up" || direction == "out"))) {
		return;
	}

	// Všechna tlačítka, která vedou na stejný cíl (abychom měli možnost jednu a tutéž nabídku rozbalovat/sbalovat z více míst)
	let toggles = document.querySelectorAll("[data-" + animationKind + "='" + elementSelector + "']");

	// Cíl rozbalení/sbalení
	let elements = document.querySelectorAll(elementSelector);

	// Akce
	if (isExpanded) {
		// Skryj položky
		return hideElements(toggles, elements, animationOut, animationKind);
	}
	else {
		// Pokud je žádáno, skryj všechny ostatní položky, které patří do stejné skupiny.
		let promises = [];
		for (let i = 0; i < otherGroups.length; ++i) {
			let otherGroup = otherGroups[i];

			if (target == otherGroup || !isTargetExpanded(otherGroup)) {
				continue;
			}

			let otherElementSelector = otherGroup.getAttribute("data-" + animationKind);
			// let otherToggles = document.querySelectorAll("[data-" + animationKind + "='" + otherElementSelector + "']");
			let otherElements = document.querySelectorAll(otherElementSelector);

			promises.push(hideElements([otherGroup], otherElements, animationOut, animationKind));
		}

		if (waitForFinish) {
			// Počkej, než se dokončí skrývání.
			return Promise.all(promises).then(function() {
				return showElements(toggles, elements, animationIn, animationKind);
			});
		}
		else {
			// Zobraz položky rovnou
			return showElements(toggles, elements, animationIn, animationKind);
		}
	}
}


// *************************************************************************
// Animation queue
// *************************************************************************

// Když uživatelé zběsile klikali, tak se animace začaly různě rozbíjet. První ochrana
// proti tomuto chování bylo ignorování kliknutí, dokud se předchozí animace nedokončila.
// Výsledek ale nebyl úplně příjemný, vypadalo to, jako když se telefon rozbil a nechce
// reagovat na uživatelovy povely. Proto jsou nyní animace za sebe skládány do fronty
// a vykonají se postupně jedna po druhé. Také to není úplně ideální, ale výsledek se
// zdá být pocitově lepší. Stálo by za úvahu přidat trochu robustnosti v případě,
// že např. dynamický element v průběhu vykonávání fronty ze stránky zmizí. Toto by
// současnou implementaci fronty nejspíše rozbilo. Fronta je společná pro všechny animace,
// další vylepšení by přidalo na robustnosti a uživatelské přívětivosti, kdyby na sobě nezávislé
// animace se mohly animovat současně (rozbalit/sbalit jedno tlačítko a přitom rozbalit/sbalit
// jiné tlačítko, které není v té samé exklusivní skupině).

function PromiseQueue() {
	this.queue = [];
	this.workingOnPromise = false;
}
PromiseQueue.prototype = {
	constructor: PromiseQueue,

	push: function(promise) {
		this.queue.push(promise);
		this._dequeue();
	},

	_dequeue: function() {
		let self = this;

		if (this.workingOnPromise) {
			return;
		}

		let promise = this.queue.shift();
		if (!promise) {
			return;
		}

		this.workingOnPromise = true;

		// Pozor, funkce nemusí nutně vrátit promise.
		let returnValue = promise();
		if (returnValue) {
			returnValue.then(function() {
				self.workingOnPromise = false;
				self._dequeue();
			})
				.catch(function() {
					self.workingOnPromise = false;
					self._dequeue();
				});
		}
		else {
			// Pokud nevrátila promise, není na co čekat a pokračujme dalším prvkem ve frontě.
			this.workingOnPromise = false;
			this._dequeue();
		}
	}
};

let animationQueue = new PromiseQueue();


// *************************************************************************
// Event
// *************************************************************************

document.addEventListener("click", function(event) {
	let target = event.target.closest("[data-slide], [data-fade]");
	if (!target) {
		hideNonStickyElements(event.target, null);
		return;
	}

	let breakpointDown = target.getAttribute("data-slide-down") || target.getAttribute("data-fade-down");
	let breakpointUp = target.getAttribute("data-slide-up") || target.getAttribute("data-fade-up");

	if ((breakpointDown && !MediaBreakpoint.down(breakpointDown)) || (breakpointUp && !MediaBreakpoint.up(breakpointUp))) {
		return
	}

	let preventDefault = (target.getAttribute("data-slide-prevent") || target.getAttribute("data-fade-prevent")) == "true"
	if (preventDefault) {
		// Explicitní požadavek na zablokování výchozí události.
		event.preventDefault();
	}
	else {
		// Potlačovat výchozí funkcionalitu budeme pouze u odkazů s prázdným "href" a tlačítek, které nebudou mít typ "submit".
		// U ostatních necháme akci proběhnout, protože to může mít nějaký další význam (jako např. sbalování comboboxů
		// při výběru nějaké z položek).
		preventLinkDefault(event, target);
	}

	hideNonStickyElements(event.target, target);

	const promise = animate.bind(null, target);
	animationQueue.push(promise);
});
